import React from "react";
import GitHubIcon from "@material-ui/icons/GitHub";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";
const Footer = () => {
  return (
    <footer className="h-28 bg-gray-900 pt-5">
      <h1 className="text-center  font-medium text-white text-xl">Social</h1>
      <div className="flex justify-center mt-5 space-x-7">
        <a
          href="https://github.com/Pavanarathod?tab=repositories"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white"
        >
          <GitHubIcon />
        </a>

        <a
          href="https://www.instagram.com/pavan_rathod_13/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white"
        >
          <InstagramIcon />
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=100009401480614"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white"
        >
          <FacebookIcon />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
